import CalculationConfig from './calculation-config';
export default CalculationConfig;
